<template>
  <div class="subform-row">
    <div
      class="subform-detail-row p-2 d-grid gap-2"
      data-test-subform-row
      v-for="(row, rowIdx) in rows"
      :key="row.rowUid"
    >
      <sub-form-row
        :path="`${path}/${rowIdx}`"
        :key="`${row.rowUid}-comp`"
        :row-id="row.rowId"
        :list-head="listHead"
        :read-only="readOnly"
        :row-index="rowIdx"
      />
      <div>
        <el-button
          v-if="showRemoveButton"
          type="primary"
          :data-test-remove-subform-row="name"
          @click.stop="onRemoveRowClick(rowIdx)"
          icon="el-icon-delete"
        />
      </div>
    </div>
  </div>
</template>

<script>
import mixinSubFormView from './mixin-sub-form-view'

export default {
  name: 'SubFormDetailView',
  mixins: [mixinSubFormView],
}
</script>

<style scoped lang="scss">
.subform-detail-row {
  grid-auto-flow: column;
  align-items: start;
  grid-template-columns: 1fr auto;
}
.subform-detail-row:nth-child(even) {
  background-color: $table-header;
}
.disabled .subform-detail-row:nth-child(even) {
  background-color: transparent !important;
}
</style>
